// Version 1.0.1
import AF from './../../helpers/AF';
import { Rect } from './../../helpers/rect';

export default class OpInview {
    active = null;

    settings = {
        start: 0.2,
        end: 0.8,
        class: 'is-inview',
        deactivate: false,
        activateCallback: null,
        deactivateCallback: null,
    };

    constructor(el, settings = null) {
        this.el = el;
        this.rect = new Rect({ el: this.el });

        this.af = AF.instance();
        this.read = this.read.bind(this);
        this.write = this.write.bind(this);
        this.activate = this.activate.bind(this);
        this.deactivate = this.deactivate.bind(this);

        if (settings === null) { // Grab from attribute
            const attr = JSON.parse(this.el.getAttribute('op-inview').replace(/'/g, '"'));
            if(attr.start) this.settings.start = parseFloat(attr.start);
            if(attr.end) this.settings.end = parseFloat(attr.end);
            if(attr.class) this.settings.class = attr.class;
            if(attr.deactivate) this.settings.deactivate = parseInt(attr.deactivate) !== 0;
        } else { // Grab from settings passed to class
            if(typeof settings.start !== 'undefined') this.settings.start = parseFloat(settings.start);
            if(typeof settings.end !== 'undefined') this.settings.end = parseFloat(settings.end);
            if(typeof settings.class !== 'undefined') this.settings.class = settings.class;
            if(typeof settings.deactivate !== 'undefined') this.settings.deactivate = parseInt(settings.deactivate) !== 0;
            if(typeof settings.activateCallback !== 'undefined') this.settings.activateCallback = settings.activateCallback;
            if(typeof settings.deactivateCallback !== 'undefined') this.settings.deactivateCallback = settings.deactivateCallback;
        }
        
        this.af.addRead(this.read);
        this.af.addWrite(this.write);
    }

    disconnect(){
        this.af.removeRead(this.read);
        this.af.removeWrite(this.write);
    }

    read() {
        this.rect.tick();
    }

    write() {
        if (this.rect.progress >= this.settings.start && 
            this.rect.progress <= this.settings.end) {
            this.activate();
        } else {
            if (this.settings.deactivate) {
                this.deactivate();
            }
        }
    }

    activate() {
        if (this.active && this.active !== null) return;
        // console.log('activate');
        this.active = true;
        this.el.classList.add(this.settings.class);

        if (this.settings.activateCallback) {
            this.settings.activateCallback();
        }

        if (!this.settings.deactivate) {
            this.af.removeRead(this.read);
            this.af.removeWrite(this.write);
        }
    }

    deactivate() {
        if (!this.active && this.active !== null) return;
        console.log('deactivate', !this.active);
        this.active = false;
        this.el.classList.remove(this.settings.class);

        if (this.settings.deactivateCallback) {
            this.settings.deactivateCallback();
        }
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/components/opInview/opInview.js